import { useState } from 'react';

export const useScaleImage = (): [boolean, () => void] => {
	const [showScaleImage, setScaleImageShow] = useState<boolean>(false);
	const toggleScaleImage = () => setScaleImageShow(prev => !prev);

	return [showScaleImage, toggleScaleImage];
};